import React, { ChangeEvent } from "react";
import { Input } from "@mui/material";
import { FieldType } from "../../../services/helpers/types";
import { generateUnit } from "../../molecules/DoctorsReport/helpers";
import { useTranslation } from "react-i18next";

interface TextFieldProps {
  field?: FieldType;
  value?: string;
  placeholder?: string;
  type?: string;
  onChange?: (value: string) => void;
  onEnter?: (value: string) => void;
}

const TextField = (props: TextFieldProps) => {
  const { field, value = "", placeholder, type, onChange, onEnter } = props;

  const { t } = useTranslation();

  const unit =
    field !== undefined ? generateUnit(t, field.unit, value) : undefined;

  const handleTextFieldChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const value = event.target.value;
    if (onChange) {
      onChange(value);
    }
  };

  const handlePressEnter = (event: any) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (onEnter) {
        onEnter(value);
      }
    }
  };

  return (
    <div className="dui-text-field-wrapper">
      <Input
        className="dui-text-field"
        onChange={handleTextFieldChange}
        value={value ? value : ""}
        endAdornment={
          unit ? <div className="dui-text-field-unit">{unit}</div> : undefined
        }
        placeholder={placeholder}
        type={type}
        onKeyDown={handlePressEnter}
      />
    </div>
  );
};

export default TextField;
